import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalTiendasFiltersDef } from "./PersonalTiendasFiltersDef";


export class PersonalTiendasFilters extends Entity<PersonalTiendasFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalTiendasFiltersDef(), parentKeys);
        this.Form = import('./PersonalTiendasFiltersForm').then((module) => module.PersonalTiendasFiltersForm);
        this.Title = "Personal Tiendas Filters";
    }
}